import React, { useCallback, useRef, useState } from 'react';
import starmapIcon from 'src/styles/landing-page/whats-due-start-map-icon.svg';
import FinanceCalendarContent from './FinanceCalendarContent';
import { useDueThisWeekData } from './hooks/useDueThisWeekData';
import MecWorkDayWidget from './MecWorkDayWidget';

/**
 * @feature landing-page
 * @description "What's Due This Week" section — MEC work day indicator + finance calendar tabs.
 */
const DueThisWeekSection: React.FC = () => {
  const { financeCalendarData, calendarStatus } = useDueThisWeekData();
  const [dismissKey, setDismissKey] = useState(0);
  const isScrollingRef = useRef(false);
  const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleScroll = useCallback(() => {
    if (!isScrollingRef.current) {
      isScrollingRef.current = true;
      setDismissKey((k) => k + 1);
    }
    if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
    scrollTimeoutRef.current = setTimeout(() => {
      isScrollingRef.current = false;
    }, 150);
  }, []);

  return (
    <div className="landing-due-this-week">
      <div className="landing-section__header">
        <h4>WHAT&apos;S DUE THIS WEEK</h4>
        <div className="landing-due-this-week__starmap">
          <img src={starmapIcon} alt="Starmap" width={20} height={20} />
          <a href="https://w.amazon.com/bin/view/D&S-FP&A/Calendar/StarMap/" target="_blank" rel="noopener noreferrer">
            DaS FP&amp;A Starmap
          </a>
        </div>
      </div>
      <div className="landing-due-this-week__content" onScroll={handleScroll}>
        <MecWorkDayWidget dismissPopover={dismissKey} />
        <FinanceCalendarContent status={calendarStatus} data={financeCalendarData} />
      </div>
    </div>
  );
};

export default DueThisWeekSection;
